module.exports = __webpack_public_path__ + "instagram-story-shadow.68f2ef148721aa93f71f30857bf4faee.svg";